import BtnTrocaImg from "../BtnTrocaImg/BtnTrocaImg";
import "./HeroProduto.css"

function HeroProduto(props) {
  return (
    <div className="containerHero" style={{ backgroundColor: `${props.cor}` }}>
      <div className="imgProdutoHero">
        <img src={props.link} alt="fofinho neutro" />
      </div>
      <div className="infosProduto">
        <img src={props.logo} alt="Logo" />
        <div className="btnTrocaHero">
          <BtnTrocaImg qtde={"4"} un={"Rolos"} cor={`${props.btnCor}`} />
          <BtnTrocaImg qtde={"8"} un={"Rolos"} cor={`${props.btnCor}`} />
          <BtnTrocaImg qtde={"12"} un={"Rolos"} cor={`${props.btnCor}`} />
        </div>
      </div>
    </div>
  )
}

export default HeroProduto;